// Moved from `src/features/dictationLogs/normalizeTone.ts` (now a re-export
// delegate) at D1 slice 1, ARCFE-1067. Body byte-identical; only the type
// specifier changed, from the app-side `types.ts` shim to the contracts door the
// birth put those names behind. That re-point is what removes this file's ONLY
// path to t11nClient — the shim's `DictationPercentileBand` tail, which serves
// the logs half alone.
import { DICTATION_TONES, type DictationTone } from '../contracts';

// Unknown/unset wire tone defaults to `formal`.
export function normalizeTone(tone: string): DictationTone {
  return (DICTATION_TONES as readonly string[]).includes(tone)
    ? (tone as DictationTone)
    : 'formal';
}
